import { Block } from '../block/block'
import { Table } from '../table/table'
import { TableContainer } from '../table/tableContainer'
import {
  DataTableHeaderCell,
  DataTablePaginator,
  DataTableRow,
  DataTableSearchBar
} from './components'
import { DataTableProvider } from './dataTable.context'
import { useDataTableFunctions } from './useDataTableFunctions'

export const DataTable = props => {
  const { isSearchable, isPaginatable, table, getTableProps, ...dataTable } =
    useDataTableFunctions(props)

  const context = {
    ...dataTable,
    table,
    isPaginatable,
    isSearchable
  }

  return (
    <DataTableProvider value={context}>
      <Block gap={16} minWidth={0} spreadX>
        {isSearchable && <DataTableSearchBar />}
        <TableContainer>
          <Table {...getTableProps()}>
            <Table.Head>
              {table.getHeaderGroups().map(headerGroup => (
                <Table.Row key={headerGroup.id}>
                  {headerGroup.headers.map(header => {
                    return (
                      <DataTableHeaderCell key={header.id} header={header} />
                    )
                  })}
                </Table.Row>
              ))}
            </Table.Head>
            <Table.Body>
              {table.getRowModel().rows.map(row => {
                return <DataTableRow key={row.id} row={row} />
              })}
            </Table.Body>
          </Table>
        </TableContainer>
        {isPaginatable && <DataTablePaginator />}
      </Block>
    </DataTableProvider>
  )
}
